import React, {FC} from 'react';

export const Tooltip: FC = () => <div />;

// This is a wrapper that allows us to use the required <a data-tip={} data-for={}> form from react-tooltip without getting
// jsx-a11y/anchor-is-valid warnings every build.
export const TooltipTrigger: FC = ({children, ...props}) => {
  return <a {...props}>{children}</a>;
};
